import { Button } from '@nxtvid/component-library';
import './InboxChatContainer.css';
const InboxChatContainer = ({selectedChatSession, messages, userInfo}) => {
return(
    <div className='inbox-chat-container'>
        {selectedChatSession ? (
            <div className='inbox-chat-session'>
                <div className='inbox-chat-messages'>
                    {messages.filter(msg => msg.chatSessionId === selectedChatSession._id).map((msg, index) => (
                        msg.fromRole === 'system' ? <div className='inbox-chat-message-container-system' key={index}>
                            <div className='inbox-chat-message-system'>
                            <p>{msg.messageContent}</p>
                            {msg.buttonText != null && msg.buttonText.trim() !== '' &&
                            msg.buttonUrl != null && msg.buttonUrl.trim() !== ''
                            ? <Button label={msg.buttonText} size='large' type='primary' onClick={()=>{window.open(msg.buttonUrl, '_blank')}} /> : null}
                            </div>
                            </div> : 
                        <div className={`inbox-chat-message-container ${msg.fromUserId === userInfo._id ? 'sent': 'received'}`} key={index}>
                            <div className={`inbox-chat-message-avatar ${msg.fromUserId === userInfo._id ? 'sent' : 'received'}`}>
                                {msg.fromUserId === userInfo._id ? userInfo.firstName.charAt(0) : userInfo._id === selectedChatSession.videographerId ? selectedChatSession.videographerName.charAt(0) : selectedChatSession.clientName.charAt(0)}
                            </div>
                            <div className={`inbox-chat-message ${msg.fromUserId === userInfo._id ? 'sent' : 'received'}`}>
                                <p>{msg.messageContent}</p>
                                <span className='inbox-chat-message-time'>
                                    {new Date(msg.dateTimeSent).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true }).replace(' ', '').toLowerCase()}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ) : (
            <div className='inbox-no-chat-selected'>Select a chat session to view messages</div>
        )}
    </div>
)
}
export default InboxChatContainer;